import * as React from 'react';
import b_ from 'b_';
import './index.scss';

const b = b_.with('page-main-title');

export const PageTitle: React.FC = ({ children }) => (
  <h1 className={b('title')} data-testid="page-title">
    {children}
  </h1>
);
